<template>
    
        <div class="site-header">
            <div class="site-logo">
                <router-link to="/"><img alt="Vue logo" src="@/assets/osj-logo.svg"></router-link>
            </div>
            
                <div v-if="mobile" class="site-navigation-toggle open" @click="openNav"></div>
                
                <div v-if="!mobile || open" class="site-navigation">
                    <div v-if="mobile" class="site-navigation-toggle close" @click="closeNav"></div>
                    <div class="site-navigation-frame">
                        <div class="main-nav">
                            <router-link to="/">
                                <span @click="closeNav">Search Jobs</span>
                            </router-link>
                            <router-link to="/dashboard/add">
                                <span @click="closeNav">Post a Job</span>
                            </router-link>
                            <router-link v-if="!loggedIn" to="/login">
                                <span @click="closeNav">Login</span>
                            </router-link>

                            <router-link v-if="!loggedIn" class="bordered-btn" to="/register">
                                <span @click="closeNav">Register</span>
                            </router-link>


                            <a v-if="dashboardPage && loggedIn" @click="logout">Logout</a>
                            <router-link v-if="!dashboardPage && loggedIn" to="/dashboard" class="btn"><span @click="closeNav">Dashboard</span></router-link>
                        </div>
                    </div>
                </div>

        </div>
    
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Navigation',
    methods : {
        ...mapActions([
            'toggleNav'
        ]),
        openNav () {
            this.toggleNav( "open" )
        },
        closeNav () {
            this.toggleNav( "close" )
        },
        logout ( e ) {
            e.preventDefault()
            this.$store.dispatch('signOut').then(() => {
                this.$router.replace('/')
            })
            
        }
    },
    computed : {
        open (){ return this.$store.state.navopen },
        mobile () { return this.$store.getters.mobile },
        loggedIn () { return this.$store.getters.loggedIn },
        dashboardPage () { return this.$route.name === "dashboard" }
    }
}
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    @import "../scss/wrapper";

    .site-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem 0;
        padding-bottom: 0.75rem;
        padding-top: 0.75rem;
    }
    .site-logo{
        flex-grow: 1;
        a{
            width: 7rem;
            display: block;

            @media screen and (min-width: $b1){
                width: 10rem;
                margin-right: 1rem;
            }
        }
    }
    .site-navigation {
        background-color: $gray;
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 10;

        @media screen and (min-width: $b1){
            position: static;
            background-color: transparent;
            display: flex;
            justify-content: flex-end;
        }
        &-label{
            color: $pale-gray;
            font-family: $sans;
            border-bottom: 1px solid #444;
            padding-bottom: 1rem;
        }
        &-toggle{
            width: 5rem;
            height: 5rem;
            border-radius: 50%;
            cursor: pointer;

            &.close{
                margin-left: auto;
                margin-top: 0.75rem;
                margin-right: 1.5rem;
                background-image: url( "../assets/close-white.svg" );
                background-position: center;
                background-repeat: no-repeat;
                background-size: 50%;
            }
            &.open{
                background-image: url( "../assets/hamburger.svg" );
                background-position: center;
                background-repeat: no-repeat;
                background-size: 50%;
                background-color: white;
                order: 2;

                @media screen and (min-width: $b1){
                    position: static;
                }
            }
        }
        &-frame{
            width: 70%;
            margin: 0 auto;
            @media screen and (min-width: $b1){
                margin: 0;
                width: auto;
                display: flex;
                flex-direction: column;
            }
        }
        .main-nav {
            @media screen and (min-width: $b1){
                display: flex;
                justify-content: flex-end;
                order: 2;
            }
        }

        a {
            display: block;
            border-bottom: 2px solid rgba( white, 0.1 );
            padding: 1rem 1rem 1rem 0;
            color: green;
            text-decoration: none;
            color: white;
            font-family: $sans;
            font-size: 3rem;
            text-transform: uppercase;
            transition: all $speed ease;
            line-height: 1;

            @media screen and (min-width: $b1){
                color: $yellow;
                margin-left: 1.5rem;
                line-height: 1;
                font-size: 1.6rem;
                font-weight: 700;
                border-radius: $radius;
                background: white;
            
                &:hover{
                    color: $blue;
                }
            }

            &.bordered-btn{
                @media screen and (min-width: $b1){
                    border: 1px solid $yellow;
                    padding-left: 1.5rem;
                    padding-right: 1.5rem;

                    &:hover{
                        border: 1px solid $blue;
                    }
                }
            }

            // &.router-link-exact-active {}
        }
    }



    .dashboard-link{
        margin-top: 1rem;
        padding-bottom: 1rem;
        border-bottom: 2px solid rgba( white, 0.1 );

        @media screen and (min-width: $b1){
            margin: 0 0 0 1.5rem;
            padding: 0;
            border-bottom: none;
            order: 1;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
</style>